import { useLang } from 'hooks/lang';

import {
  calculateCountryServiceCost,
  calculateProjectTotal,
  Project,
  ProjectService,
} from 'entities';

import { ChevronDownIcon, ChevronUpIcon, CircleDollarIcon } from 'components/Icons';
import { PropertyWithIcon } from 'components/PropertyWithIcon';
import { Card, Collapse, getTableColumns, IconButton, Row, Table } from 'components/Blocks';

import { useToggleV2 } from 'hooks';

import { formatCurrency } from 'utils/text';
import { sortByName } from 'utils/array';

interface Props {
  project: Project;
}

export function ProjectValueView({ project }: Props) {
  const { t } = useLang();

  const [showServices, { toggle }] = useToggleV2();

  return (
    <>
      <PropertyWithIcon
        icon={<CircleDollarIcon />}
        name={t('current-value')}
        value={
          <Row gap="2">
            {formatCurrency(calculateProjectTotal(project.services), project.currency)}

            <IconButton onClick={toggle} tooltipContent={t('view-cost-breakdown')}>
              {showServices ? <ChevronUpIcon size={14} /> : <ChevronDownIcon size={14} />}
            </IconButton>
          </Row>
        }
      />

      <Collapse expanded={showServices} onlyRenderIfExpanded>
        <Card spacing="small">
          <Table
            items={sortByName(project.services)}
            uniqueKey="id"
            headerClassName="pb-2"
            columns={[
              {
                label: t('service'),
                property: 'name',
              },
              ...getTableColumns<ProjectService>(
                project.countries.map((country) => ({
                  label: country,
                  render: ({ costCalculation, costs }) =>
                    formatCurrency(
                      calculateCountryServiceCost(costs[country], costCalculation),
                      project.currency,
                    ),
                })),
              ),
            ]}
          />
        </Card>
      </Collapse>
    </>
  );
}
